import SvgOptions from "../../../Components/Svg/SvgOptions";
import AnnouncementDetails from "./AnnouncementDetails/AnnouncmentDetails";
import AnnouncementList from "./AnnouncementList";
import AddAnnouncement from "./AddAnnouncement/CreateAnnouncement";

const AnnouncementNavOptions = [
	{
		element: AnnouncementDetails,
		path: ":id",
		access: { user: true, admin: true, super: true },
		Protected: false,
		default: true,
		icon: SvgOptions.Dashboard,
	},
	{
		element: AddAnnouncement,
		path: "create",
		access: { user: true, admin: true, super: true },
		Protected: false,
		default: true,
		icon: SvgOptions.Dashboard,
	},


];
const defaultRoute = {
	element: AnnouncementList,
	path: "*",
	access: { user: true, admin: true, super: true },
	Protected: false,
	default: true,
	icon: SvgOptions.Dashboard,
};
export { defaultRoute };
export default AnnouncementNavOptions;
